import { Injectable, signal, computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AwsAuthService } from "../aws-auth.service";

@Injectable({ providedIn: 'root' })
export class CountrySelectionService {

  private _showCountrySelection = signal(false);
  showCountrySelection = this._showCountrySelection.asReadonly();

  private _configReady = signal(false);
  configReady = this._configReady.asReadonly();

  private _selectedCountry = signal<string | null>(null);

  shouldShowPanel = computed(() =>
    this.configReady() &&
    this._showCountrySelection()
  );

  private router = inject(Router)
  private authService = inject(AwsAuthService)

  markConfigReady() {
    this._configReady.set(true);
  }

  triggerCountrySelection() {
    this._showCountrySelection.set(true);
  }

  setCountry(country: string) {
    localStorage.setItem('countryOfOrigin', country)
    this._selectedCountry.set(localStorage.getItem('countryOfOrigin'));
    this.authService.manageLogoutResponse();
  }

  checkIfUserCountryOfOriginExists(): boolean {
    const countryOfOrigin = localStorage.getItem('countryOfOrigin');
    return countryOfOrigin ? true: false;
  }
}